import * as React from 'react';

import type { SupplierDashboardClient } from '@/api/supplier-dashboard-client';
import { HttpSupplierDashboardClient } from '@/api/supplier-dashboard-client.http';

// =============================================================================
// supplier-dashboard-client-context.tsx — Injection du SupplierDashboardClient (DI seam, Lot A / D3b).
// =============================================================================
// Permet de substituer le client sans toucher l'UI. Par défaut : l'adaptateur HTTP RÉEL
// (HttpSupplierDashboardClient) — le BACK dashboard fournisseur est livré (D3b). Câblé HTTP DÈS LE DÉPART
// (garde 09_stub_in_prod_guard : aucun défaut stub-en-prod). Les tests de composant injectent un
// StubSupplierDashboardClient (double déterministe) via le provider.

/** Adaptateur par défaut : HTTP réel (chemins relatifs racine API, cookie de session fournisseur). */
const defaultSupplierDashboardClient: SupplierDashboardClient =
  new HttpSupplierDashboardClient();

const SupplierDashboardClientContext =
  React.createContext<SupplierDashboardClient>(defaultSupplierDashboardClient);

export interface SupplierDashboardClientProviderProps {
  client?: SupplierDashboardClient | undefined;
  children: React.ReactNode;
}

export function SupplierDashboardClientProvider({
  client = defaultSupplierDashboardClient,
  children,
}: SupplierDashboardClientProviderProps): React.JSX.Element {
  return (
    <SupplierDashboardClientContext.Provider value={client}>
      {children}
    </SupplierDashboardClientContext.Provider>
  );
}

export function useSupplierDashboardClient(): SupplierDashboardClient {
  return React.useContext(SupplierDashboardClientContext);
}
